export { ProposalRaterComponent } from './lib/proposal-rater.component';
